// Shared styling for MUI DatePicker calendar popup
// Provides a dark theme with solid background for better readability

export const datePickerPopperSx = {
  '& .MuiPaper-root': {
    backgroundColor: 'rgba(30, 30, 30, 0.98)',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    color: 'white',
  },
  '& .MuiPickersCalendarHeader-root': {
    color: 'white',
  },
  '& .MuiPickersCalendarHeader-label': {
    color: 'white',
  },
  '& .MuiIconButton-root': {
    color: 'rgba(255, 255, 255, 0.7)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  '& .MuiDayCalendar-weekDayLabel': {
    color: 'rgba(255, 255, 255, 0.6)',
  },
  '& .MuiPickersDay-root': {
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    '&.Mui-selected': {
      backgroundColor: '#1976d2',
      '&:hover': {
        backgroundColor: '#1565c0',
      },
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.3)',
    },
  },
  '& .MuiPickersDay-today': {
    border: '1px solid rgba(255, 255, 255, 0.5)',
  },
  '& .MuiPickersYear-yearButton': {
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    '&.Mui-selected': {
      backgroundColor: '#1976d2',
      '&:hover': {
        backgroundColor: '#1565c0',
      },
    },
  },
  '& .MuiClock-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiClockNumber-root': {
    color: 'white',
  },
  '& .MuiClock-pin': {
    backgroundColor: '#1976d2',
  },
  '& .MuiClockPointer-root': {
    backgroundColor: '#1976d2',
  },
  '& .MuiClockPointer-thumb': {
    backgroundColor: '#1976d2',
    borderColor: '#1976d2',
  },
  '& .MuiDialogActions-root': {
    '& .MuiButton-root': {
      color: '#1976d2',
    },
  },
};
